import { api } from '~/services/api';
import ICustomAxiosRequestConfig from '~/services/custom/ICustomAxiosRequestConfig';
import type { Pagination } from '~/services/pagination';

export type Banner = {
  id: string;
  external_link: string | null;
  file: string;
  scrolls_to: string | null;
  type: string;
  order: number;
  expires_at: Date;
  internal_link:
    | {
        to: string;
      }
    | never[]
    | null;
};
type BannersParams = {
  type: string;
  unit_id: string;
  sort_order?: string;
};

type GetBannersProps = {
  success: boolean;
  data: Banner[];
  pagination: Pagination;
  status: number;
};

export const getBanners = async (
  params: BannersParams,
  serverSide?: { serverSide: boolean }
): Promise<GetBannersProps> => {
  const { data, status } = await api.get(
    `/document/v1/banners?type=${params.type}&consult_id=${
      params.unit_id
    }&sort_field=${params.sort_order || 'order'}`,
    {
      serverSide,
    } as ICustomAxiosRequestConfig
  );

  return {
    success: data.success,
    data: data.data,
    pagination: data.pagination,
    status,
  };
};
